import { Typography } from '@mui/material';
import { Container } from '@mui/system';
import t from '../../theme';
import { blueRibbonStyle } from '../../style';
import { CaseStages } from '../../lib/constants/misc';

interface BlueRibbonProps {
    title: string;
    appealedCodeNumber: number;
    doctor?: string;
    dateTime?: string;
    timeTaken?: number;
}

const BlueRibbon = ({
    title,
    appealedCodeNumber,
    doctor,
    dateTime,
    timeTaken
}: BlueRibbonProps) => {
    const isReconsideration = title === CaseStages.Reconsideration;
    const isCosign = title.includes('Cosign');
    const isAudit = title.includes('Audit');

    return (
        <Container
            sx={{
                height: 'fit-content',
                width: '100%',
                background: t.palette.primary.main,
                margin: 0,
                minWidth: '100%'
            }}>
            {isReconsideration || isCosign ? (
                <Typography sx={blueRibbonStyle}>
                    This is a {isCosign ? 'Cosign' : title}
                </Typography>
            ) : isAudit ? (
                <Typography sx={blueRibbonStyle}>
                    This is an <strong>Audit</strong>{' '}
                    {doctor && dateTime && timeTaken
                        ? `| Case was submitted by Dr. ${doctor} at ${dateTime} and took ${timeTaken} minutes`
                        : ''}
                </Typography>
            ) : (
                <Typography sx={blueRibbonStyle}>
                    This is a {title} | There {appealedCodeNumber > 1 ? 'are' : 'is'}{' '}
                    <strong>{appealedCodeNumber} appealed</strong>{' '}
                    {appealedCodeNumber > 1 ? 'codes' : 'code'} for review
                </Typography>
            )}
        </Container>
    );
};

export default BlueRibbon;
